// extracted by mini-css-extract-plugin
module.exports = {"btn":"CommonPopup__btn--X0f"};